module.exports = __webpack_public_path__ + "static/img/productBg.9282900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productBg.png
// module id = UFe7
// module chunks = 1